import gql from 'graphql-tag';

export const DELETE_INVITATION = gql`
  mutation deletePendingInvitation($invitationId: Int!) {
    invitation {
      deleteInvitation(invitation: $invitationId)
    }
  }
`;
